// ============= Imports =============
import React, { Fragment } from 'react';
import { ProgressBar, ProgressConnector, ProgressStep } from './styles';

export interface VisualPromptProgressProps {
  steps: { id: string; title: string }[];
  currentIndex: number;
}

// ============= Component =============
export const VisualPromptProgress: React.FC<VisualPromptProgressProps> = ({
  steps,
  currentIndex,
}) => (
  <ProgressBar>
    {steps.map((step, index) => (
      <Fragment key={step.id}>
        <ProgressStep
          $active={index === currentIndex}
          $completed={index < currentIndex}
        >
          {index + 1}
        </ProgressStep>
        {index < steps.length - 1 && (
          <ProgressConnector $active={index < currentIndex} />
        )}
      </Fragment>
    ))}
  </ProgressBar>
);
